(function() {
    const collectionBanners = () => {
        const imageCallout = document.querySelector('.td-collection-callout-image-banner');
        const cardBanner = document.querySelector('.td-collection-card-banner');
        const firstCard = Array.from(document.querySelectorAll('.product-card-wrapper'))[0]
        if(imageCallout || cardBanner) {
            const h = firstCard && firstCard.clientHeight || 400;
            const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            
            if (viewportWidth < 751) {
             
               if(imageCallout) imageCallout.style.height = `${h}px`;
               if(cardBanner) cardBanner.style.height = `${h}px`;
            }
            window.addEventListener("resize", (event) => {
          
                if (document.body.clientWidth > 751) {
       
                    if(imageCallout) imageCallout.style.height = 'auto';
                    if(cardBanner) cardBanner.style.height = 'auto';
                } else {
             
                    if(imageCallout) imageCallout.style.height = `${h}px`;
                    if(cardBanner) cardBanner.style.height = `${h}px`;
                }
            });
        }
    }
    const hideBanners = () => {
        const banners = Array.from(document.querySelectorAll('.td-collection-banner'))
     
        if(banners.length) {
            const desktopCount = document.getElementById('ProductCountDesktop');
            const mobileCount = document.getElementById('ProductCount');
            const body = document.querySelector('body');
            if(desktopCount.innerText.includes('of')) {
                body.classList.add('filters-on');
            }
            if(mobileCount.innerText.includes('of')) {
                body.classList.add('filters-on');
            }
            
            const observerDesktop = new MutationObserver((mutationsList) => {
              for (const mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.target === desktopCount) {
                  if (desktopCount.textContent.includes('of')) {
                    body.classList.add('filters-on');
                  
                  } else {
                    body.classList.remove('filters-on');
                  
                  }
                }
              }
            });
            
           
            const observerMobile = new MutationObserver((mutationsList) => {
              for (const mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.target === mobileCount) {
                  if (mobileCount.textContent.includes('of')) {
                    body.classList.add('filters-on');
                    
                  } else {
                    body.classList.remove('filters-on');
                    
                  }
                }
              }
            });
            
            const config = {
              childList: true,
              subtree: true,
              characterData: true,
            };
            
         
            observerDesktop.observe(desktopCount, config);
            observerMobile.observe(mobileCount, config);
    
        }
    }
    const mainBannerImage = () => {
      const imageWrapper = document.querySelector('.collection-header-left-image:not(.natural-dimensions)')
      const image = imageWrapper.querySelector('img')
      const imageHeightUpdate = function(){
        image.style.height = `${imageWrapper.getBoundingClientRect().width}px`
        
      }
      if(imageWrapper && image) {
        image.style.visibility = 'inherit'
        imageHeightUpdate()
        window.addEventListener("resize", (event) => {
          imageHeightUpdate()
        })
      }
    }
  mainBannerImage()
  collectionBanners()
  hideBanners()
  })();
  

